import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';

class ControlSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('.splide');

    this.slider = null;
    this.option = {
      type: 'fade',
      rewind: true,
      perPage: 1,
      gap: `min(${24 / 16}rem, ${24 / 375 * 100}vw)`, 
      speed: 900,
      arrows: true,
      pagination: true,
      lazyLoad: 'nearby',
      // drag: false,
      // items:PaginationItem[]
      mediaQuery: 'min',
      breakpoints: {
        768: {
          // type: 'loop',
          gap: `min(${24 / 16}rem, ${24 / 1440 * 100}vw)`,
          focus: 'center',
        }
      }
    };

    this.init();
  }

  init() {
    this.slider = new Splide(this.dom.slider, this.option);

    this.slider.on('pagination:mounted', (data)=>{
      data.list.classList.add('splide__pagination--custom');
      data.items.forEach((item)=>{
        item.button.innerHTML = '<svg viewBox="0 0 18 18"><use xlink:href="#masu-square"></use></svg>';
      });
    });

    this.slider.mount();
  }
}

export default ControlSlides